module.exports = __webpack_public_path__ + "static/img/bushes-after-min.0a5b22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/bushes-after-min.png
// module id = 648
// module chunks = 64